<template>
  <div class="dialog">
    <van-dialog 
      v-model="show" 
      :title="title" 
      width="290" 
      :showConfirmButton="showConfirmButton" 
      :showCancelButton="showCancelButton" 
      closeOnClickOverlay
      confirmButtonColor="#222222"
      @confirm="confirm"
    >
      <i class="delete-icon" @click="close" />
      <div class="content" v-html="text">
        <!-- <p>{{ text }} <b>{{ integral }}</b></p> -->
      </div>
    </van-dialog>
  </div>
</template>
<script>
// import http from '../../cmmon/js/http.js'
export default {
  name: 'popupTemp',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    },
    showCancelButton: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: ''
    },
    integral: {
      type: Number,
      default: null
    },
    titles: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isShow: this.show
    }
  },
  mounted() {
    console.log(this.show, this.isShow)
  },
  methods: {
    close() {
      this.$emit('closeDialog')
    },
    confirm() {
      this.$emit('submitTips')
    }
  }
}
</script>


<style lang="less" scoped>
.dialog {
  position: relative;
  .van-dialog {
    // padding-top: 30px;
  }
  .content {
    width: 100%;
    height: 80px;
    text-align: center;
    // display: flex;
    p {
      margin: auto;
      b {
        color: #D80A68;
        font-weight: bold;
      }
    }
  }
}
.delete-icon {
  display: block;
  width: 14px;
  height: 14px;
  background: url('../../image/Gb@2x.png') no-repeat;
  background-size: contain;
  position: absolute;
  right: 15px;
  top: 15px;
}
</style>